import { FC } from "react";
import { AvailableSidebarContentType } from "../../store/sidebar-store";
import { ContactDetailsSidebarHeaderContent } from "./ContactDetailsSidebarContent";

export const SIDEBAR_PANEL_HEADER_CONTENT_COMPONENT_MAP = {
  ContactDetails: ContactDetailsSidebarHeaderContent,
} as const satisfies Record<AvailableSidebarContentType, FC>;
